// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Showroom: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40  29" 
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
                <path d="M47.87 23.95H0v-1.57l.31-.03h47.56v1.59ZM25.51 5.57h.81V3.61c0-1.01.2-1.21 1.2-1.21h8c.96 0 1.18.22 1.18 1.19V5.6h1.45c.65.01.93.3.93.95v1.4c.19 0 .36.02.52.03h5.52c.89 0 1.15.26 1.15 1.14v11.32c0 .86-.25 1.12-1.11 1.12H2.68c-.89 0-1.13-.25-1.13-1.15V6.75c0-.9.24-1.15 1.13-1.15l1.92-.01c.03 0 .06-.02.15-.06V3.56c0-.9.25-1.16 1.12-1.16h7.34c.89 0 1.12.25 1.13 1.15v2.02h.76l.02-.49V1.1c.01-.84.28-1.1 1.14-1.1h8.14c.86 0 1.11.25 1.11 1.11v4.46Zm11.94 14.36V7.22H3.18v12.7h7.17v-9.16c0-.95.23-1.19 1.19-1.19h18.39c.95 0 1.19.25 1.19 1.2v9.16h6.34ZM39.1 9.6v10.32h5.55V9.61H39.1ZM11.96 19.92h4.74v-8.71h-4.74v8.71Zm11.14 0v-8.7h-4.74v8.7h4.74Zm1.66-8.72v8.72h4.73V11.2h-4.73Zm-8-5.64h7.14V1.62h-7.14v3.94Zm11.19 0h7.12V4.02h-7.12v1.54Zm-21.57 0h6.34V4.02H6.37v1.54Z"/>
        </svg>
    );
};

export default React.memo(Showroom);
